import { defineComponent } from 'vue';
import { v4 as uuid } from 'uuid';
export default defineComponent({
    name: 'Tab',
    compatConfig: {
        MODE: 3,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        isActive: {
            type: Function,
            required: true,
        },
        registerTab: {
            type: Function,
            required: true,
        },
        destroyTabWhenInactive: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            id: uuid(),
        };
    },
    mounted() {
        this.registerTab(this.label, this.id);
    },
});
